function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0s",
  calcMode: "discrete"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 0,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.12376237623762376s",
  calcMode: "discrete"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 0,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.24752475247524752s",
  calcMode: "discrete"
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 11,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.8663366336633663s",
  calcMode: "discrete"
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 11,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.3712871287128713s",
  calcMode: "discrete"
}));

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 22,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.7425742574257426s",
  calcMode: "discrete"
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 22,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.6188118811881188s",
  calcMode: "discrete"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 22,
  width: 10,
  height: 10,
  fill: "#e15b64"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  values: "#627794;#e15b64;#e15b64",
  keyTimes: "0;0.125;1",
  dur: "0.9900990099009901s",
  repeatCount: "indefinite",
  begin: "0.49504950495049505s",
  calcMode: "discrete"
}));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {},
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.7ecc28b4.svg";
export { ForwardRef as ReactComponent };